// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__K7l4w","content":"styles_content__2Ku1r","tableWrap":"styles_tableWrap__2oqGu"};